/**
 * Check if the cif is valid
 * @param {string} cif
 * @returns {boolean}
 */
export function checkCIF(cif) {
  // sanitize cif by removing the RO prefix in case does it exist
  cif = cif.toUpperCase().replace('RO', '');

  if (isNaN(cif)) return false;
  if (cif.length > 10) return false;

  let cifra_control = cif.slice(-1);
  cif = cif.slice(0, -1);

  while (cif.length != 9) {
    cif = '0' + cif;
  }

  let suma =
    cif[0] * 7 +
    cif[1] * 5 +
    cif[2] * 3 +
    cif[3] * 2 +
    cif[4] * 1 +
    cif[5] * 7 +
    cif[6] * 5 +
    cif[7] * 3 +
    cif[8] * 2;
  suma = suma * 10;
  let rest = suma % 11;
  if (rest == 10) rest = 0;

  return rest == cifra_control;
}
